export default "__VITE_ASSET__DJc0hsBz__$_?component__"